// AdminFrontend/src/unicodex_ui/admin/AdminApp.jsx
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import "./styles/AdminLoginPage.css";
import "./styles/Admin.css";
import AdminNav from "./components/AdminNav";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminApplicationsPage from "./pages/AdminApplicationsPage";
import AdminAuditPage from "./pages/AdminAuditPage";
import AdminRiskPage from "./pages/AdminRiskPage";
import AdminBranchesPage from "./pages/AdminBranchesPage";
import AdminLocationsPage from "./pages/AdminLocationsPage";
import AdminStockLevelsPage from "./pages/AdminStockLevelsPage";
import AdminStockMovementsPage from "./pages/AdminStockMovementsPage";
import AdminReceiveManufacturedPage from "./pages/AdminReceiveManufacturedPage";
import AdminSuppliersPage from "./pages/AdminSuppliersPage";
import AdminPurchaseOrdersPage from "./pages/AdminPurchaseOrdersPage";
import AdminGoodsReceiptsPage from "./pages/AdminGoodsReceiptsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminPosTerminalsPage from "./pages/AdminPosTerminalsPage";
import AdminPosShiftsPage from "./pages/AdminPosShiftsPage";
import AdminPosSalesPage from "./pages/AdminPosSalesPage";
import AdminPosInventoryApprovalsPage from "./pages/AdminPosInventoryApprovalsPage";
import AdminShipmentsPage from "./pages/AdminShipmentsPage";
import AdminShipmentDetailPage from "./pages/AdminShipmentDetailPage";
import AdminShipmentApprovalsPage from "./pages/AdminShipmentApprovalsPage";
import AdminForecastPage from "./pages/AdminForecastPage";
import AdminComplianceDashboardPage from "./pages/AdminComplianceDashboardPage";
import AdminVerificationsSummaryPage from "./pages/AdminVerificationsSummaryPage";
import AdminComplianceShipmentsPage from "./pages/AdminComplianceShipmentsPage";
import AdminJournalEntriesPage from "./pages/AdminJournalEntriesPage";
import AdminJournalEntryDetailPage from "./pages/AdminJournalEntryDetailPage";
import AdminTrialBalancePage from "./pages/AdminTrialBalancePage";
import AdminPnLPage from "./pages/AdminPnLPage";
import AdminTaxSummaryPage from "./pages/AdminTaxSummaryPage";
import AdminMeteredPage from "./pages/AdminMeteredPage";

function RequireAdmin({ children }) {
  const token = localStorage.getItem("ucx_admin_token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

function AdminApp() {
  const [adminEmail, setAdminEmail] = useState(
    () => localStorage.getItem("ucx_admin_email") || ""
  );
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("ucx_admin_token");
  const showNav = Boolean(token) && location.pathname !== "/login";

  useEffect(() => {
    setAdminEmail(localStorage.getItem("ucx_admin_email") || "");
  }, []);

  function handleLoginSuccess(token, admin, redirectPath) {
    localStorage.setItem("ucx_admin_token", token);
    localStorage.setItem("ucx_admin_email", admin.email || "");
    setAdminEmail(admin.email || "");
    navigate(redirectPath || "/applications", { replace: true });
  }

  function handleLogout() {
    localStorage.removeItem("ucx_admin_token");
    localStorage.removeItem("ucx_admin_email");
    setAdminEmail("");
    navigate("/login", { replace: true });
  }

  return (
    <div className="ucx-body">
      {showNav && <AdminNav adminEmail={adminEmail} onLogout={handleLogout} />}
      <main className="ucx-main">
        <Routes>
          <Route
            path="/login"
            element={<AdminLoginPage onLoginSuccess={handleLoginSuccess} />}
          />
          <Route
            path="/applications"
            element={
              <RequireAdmin>
                <AdminApplicationsPage
                  adminEmail={adminEmail}
                  onLogout={handleLogout}
                />
              </RequireAdmin>
            }
          />
          
          <Route
         path="/audit-logs"
         element={
             <RequireAdmin>
                 <AdminAuditPage
                     adminEmail={adminEmail}
                     onLogout={handleLogout}
                 />
             </RequireAdmin>
         }
     />

     <Route
         path="/risk-events"
         element={
             <RequireAdmin>
                 <AdminRiskPage
                     adminEmail={adminEmail}
                     onLogout={handleLogout}
                 />
             </RequireAdmin>
         }
     />
     <Route
        path="/metered"
        element={
          <RequireAdmin>
            <AdminMeteredPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

     <Route
        path="/analytics/forecast"
        element={
          <RequireAdmin>
            <AdminForecastPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/compliance/overview"
        element={
          <RequireAdmin>
            <AdminComplianceDashboardPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/compliance/verifications"
        element={
          <RequireAdmin>
            <AdminVerificationsSummaryPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/compliance/shipments"
        element={
          <RequireAdmin>
            <AdminComplianceShipmentsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

     <Route
        path="/branches"
        element={
          <RequireAdmin>
            <AdminBranchesPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/locations"
        element={
          <RequireAdmin>
            <AdminLocationsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/stock-levels"
        element={
          <RequireAdmin>
            <AdminStockLevelsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/stock-movements"
        element={
          <RequireAdmin>
            <AdminStockMovementsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/receive-manufactured"
        element={
          <RequireAdmin>
            <AdminReceiveManufacturedPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/suppliers"
        element={
          <RequireAdmin>
            <AdminSuppliersPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/purchase-orders"
        element={
          <RequireAdmin>
            <AdminPurchaseOrdersPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/goods-receipts"
        element={
          <RequireAdmin>
            <AdminGoodsReceiptsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/users"
        element={
          <RequireAdmin>
            <AdminUsersPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/pos-terminals"
        element={
          <RequireAdmin>
            <AdminPosTerminalsPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/pos-shifts"
        element={
          <RequireAdmin>
            <AdminPosShiftsPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/pos-sales"
        element={
          <RequireAdmin>
            <AdminPosSalesPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/pos-inventory-approvals"
        element={
          <RequireAdmin>
            <AdminPosInventoryApprovalsPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/logistics/shipments"
        element={
          <RequireAdmin>
            <AdminShipmentsPage adminEmail={adminEmail} onLogout={handleLogout} />
          </RequireAdmin>
        }
      />

      <Route
        path="/logistics/shipments/:id"
        element={
          <RequireAdmin>
            <AdminShipmentDetailPage />
          </RequireAdmin>
        }
      />

      <Route 
        path="/logistics/shipment-approvals"
        element={
          <AdminShipmentApprovalsPage
          adminEmail={adminEmail} onLogout={handleLogout} />
        }
      />

      <Route
        path="/accounting/journal-entries"
        element={
          <RequireAdmin>
            <AdminJournalEntriesPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/accounting/journal-entries/:id"
        element={
          <RequireAdmin>
            <AdminJournalEntryDetailPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/accounting/trial-balance"
        element={
          <RequireAdmin>
            <AdminTrialBalancePage />
          </RequireAdmin>
        }
      />

      <Route
        path="/accounting/pnl"
        element={
          <RequireAdmin>
            <AdminPnLPage />
          </RequireAdmin>
        }
      />

      <Route
        path="/accounting/tax-summary"
        element={
          <RequireAdmin>
            <AdminTaxSummaryPage />
          </RequireAdmin>
        }
      />


          <Route
            path="*"
            element={<Navigate to="/audit-logs" replace />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default AdminApp;
